import React, { Component } from 'react';
import config from 'react-global-configuration';
import { Button, Modal, Grid, Row, Col, Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';

// Importação do Router
import { Redirect, Link } from 'react-router-dom';
import Loading from '../../Miscelania/Loading';
import Alerta from '../../Miscelania/Alerta';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import DatePicker from 'react-bootstrap-date-picker';
import AlertaInline from '../../Miscelania/AlertaInline';
import RequestApi from '../../Miscelania/RequestApi';

const PropTypes = require('prop-types');

class ExamAcoes extends Component {
  desativar_loading () {
    this.setState({status_loading: 0});
  } 
  desativar_alerta () {
    this.setState({status_alerta: 0});
  } 

  // Handlers de form
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  constructor(props) {
    super(props);

    this.state = {
      status_loading: 0,
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      class_edit: '',
      class_status: '',
      alt_status: '',
      title_status: '',
      exam_date: '',
      hora_inicial: '',
      hora_final: '',
      message_justification: '',
      modal: false,
      dados: [],
      lista_instrutores: [],
      lista_provas: [],
      questao: {},
      questoes: {},
      opcoes: [],
      questao_selecionada: 'undefined',
      message_contest: '',
      carregando_prova: 0,
      validate: 0,
    };
    //bind geral
    // handleChange e handleChangeSelect necessitam do bind nas tags
    this.handleChangeDateStartPicker = this.handleChangeDateStartPicker.bind(this);
    this.desativar_alerta = this.desativar_alerta.bind(this);
    this.desativar_loading = this.desativar_loading.bind(this);
    this.showModal = this.showModal.bind(this);
    this.atualizarQuestao = this.atualizarQuestao.bind(this);
    this.questaoSelecionada = this.questaoSelecionada.bind(this);
    this.verificarQuestaoSelecionada = this.verificarQuestaoSelecionada.bind(this);
    this.buscarQuestoes = this.buscarQuestoes.bind(this);
    this.reaplicarProva = this.reaplicarProva.bind(this);
    this.reaplicarAgora = this.reaplicarAgora.bind(this);
    this.justificar = this.justificar.bind(this);
    this.validar = this.validar.bind(this);
    this.recarregarQuestoes = this.recarregarQuestoes.bind(this);
    this.refreshAll = this.refreshAll.bind(this);
  }

  handleChangeDateStartPicker(value, formattedValue) {
    this.setState({
      exam_date: value,
      date_start_str: formattedValue,
    });
  }
  atualizarQuestao (value) {
    this.setState({questaoSelecionada: value});
    return true;
  }

  questaoSelecionada (questao_selecionada) {
    var atualizacao = this.atualizarQuestao(questao_selecionada);
    var self = this;
    Promise.resolve(atualizacao).then(function(value) {
      self.verificarQuestaoSelecionada();
    });
  }

  buscarQuestoes () {
    var url = config.get('api') + '/prova/usuario/buscar_questoes/' + this.props.dadosProva.id
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({questoes: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  recarregarQuestoes (event) {
    var url = config.get('api') + '/prova/usuario/buscar_questoes/' + this.props.dadosProva.id
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({questoes: responseJson.data});
          self.setState({status_alerta: 1});
          self.setState({mensagem_alerta: event.message});
          self.setState({tipo_alerta: event.status});
          self.questaoSelecionada(self.state.questaoSelecionada);
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  verificarQuestaoSelecionada () {
    if(this.state.questaoSelecionada === null || typeof this.state.questaoSelecionada === 'undefined') {
      this.context.router.history.push('/usuario/prova');
    } else {
      var questao = this.state.questoes[this.state.questaoSelecionada];
      var opcoes = questao.team_training_matter_staff_exam_question_option;
      this.setState({
        questao: questao,
        opcoes: opcoes,
        message_justification: '',
      });
    }
  }
  
  showModal(event) {
    this.setState({ modal: true }, this.buscarQuestoes());
  }

  reaplicarProva() {
    var dados_salvar = {
      dados: this.props.dadosProva,
      exam_date: this.state.date_start_str,
      hora_inicial: this.state.hora_inicial,
      hora_final: this.state.hora_final,
    };
    var self = this;
    self.setState({carregando_prova: 1});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova/instrutor/reaplicar_prova', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        self.setState({carregando_prova: 0});
        if (responseJson.status === 'success') {
          self.setState({status_alerta: 1});
          self.setState({mensagem_alerta: responseJson.message});
          self.setState({tipo_alerta: responseJson.status});
          self.props.recarregarProvas();
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  reaplicarAgora() {
    var dados_salvar = {
      dados: this.props.dadosProva,
    };
    var self = this;
    self.setState({carregando_prova: 1});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/prova/instrutor/reaplicar_prova_agora', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        self.setState({carregando_prova: 0});
        if (responseJson.status === 'success') {
          self.setState({status_alerta: 1});
          self.setState({mensagem_alerta: responseJson.message});
          self.setState({tipo_alerta: responseJson.status});
          self.props.recarregarProvas();
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  justificar(value) {
    var dados = {
      'question_id': value,
      'justification': this.state.message_justification,
    };
    var self = this;

    var confirm = window.confirm('Tem certeza que gostaria de justificar essa questão sem valida-la?');
    if (confirm) {
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/usuario/justificar_questao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(dados) }).then((response) => response.json()).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          self.recarregarQuestoes(responseJson);
        }).catch((error) => {
          return error;
        });
      });
    }
  }

  validar(value) {
    var dados = {
      'question_id': value,
      'justification': this.state.message_justification,
      'questions': this.state.questoes,
    };
    var self = this;

    var confirm = window.confirm('Tem certeza que gostaria de validar essa questão?');
    if (confirm) {
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/prova/usuario/validar_questao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(dados) }).then((response) => response.json()).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          self.refreshAll(responseJson);
        }).catch((error) => {
          return error;
        });
      });
    }
  }
  
  refreshAll (event) {
    var self = this;
    var header = this.recarregarQuestoes(event);
    Promise.resolve(header).then(function(value) {
      //self.props.recarregarProvas();
    });
  }



  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  {(this.state.status_loading != 0) ? <Loading ativo={this.state.status_loading} desativar={this.desativar_loading} />: ""}
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
      {(this.props.dadosProva.status != 'reprovada') ? 
      <button title="Verificar prova aprovada." alt="Verificar prova aprovada" onClick={this.showModal} className={this.props.dadosProva.contested == 1 ? 'btn btn-warning btn-xs' : 'btn btn-success btn-xs'}><i className={this.props.dadosProva.contested == 1 ? "fa fa-fw fa-envelope" : "fa fa-fw fa-check-circle"}></i></button>
      :
      <button title="Verificar prova reprovada." alt="Verificar prova reprovada" onClick={this.showModal} className={this.props.dadosProva.contested == 1 ? 'btn btn-warning btn-xs' : 'btn btn-danger btn-xs'}><i className={this.props.dadosProva.contested == 1 ? "fa fa-fw fa-envelope" : "fa fa-fw fa-times-circle"}></i></button>
      }

  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-sm" bsSize={'large'}>
    <Modal.Header className='modal-prova'>
      <div className="row">
        <div className="col-md-6">
            <h4 className="pull-left"><b>Revisão de prova do aluno: {this.props.dadosProva.staff.name}</b></h4>
        </div>
        <div className="col-md-6">
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </div>
      </div>
    </Modal.Header>
    <Modal.Body className='modal-prova'>
      <div className="row dados-prova-modal">
        <div className="col-md-6">
            <p><b>Código: </b>{this.props.dadosProva.id}</p>
              {(this.props.dadosProva.training !== null) ?
                <p><b>Treinamento: </b>{this.props.dadosProva.training.name}</p>
              :
                <p><b>Treinamento: </b>Prova avulsa</p>
              }
            <p><b>Matéria: </b>{this.props.dadosProva.matter.name}</p>
            <p><b>Status: </b><span className={(self.props.dadosProva.status == 'aprovada') ? 'label-success' : 'label-danger'}>{(self.props.dadosProva.status == 'aprovada') ? 'Aprovada' : 'Reprovada'}</span></p>
            <p><b>Início: </b>{this.props.dadosProva.exam_applied_start_str}</p>
            <p><b>Fim: </b>{this.props.dadosProva.exam_applied_finish_str}</p>
        </div>

        <div className="col-md-6">
            <p><b>Total de questões: </b>{this.props.dadosProva.qtd_questoes}</p>
            <p><b>Acertos: </b>{this.props.dadosProva.qtd_acertadas}</p>
            <p><b>Erros: </b>{this.props.dadosProva.qtd_erradas}</p>
            <p><b>Nota: </b>{this.props.dadosProva.result}</p>
            <p><b>Tempo total de prova:</b> {this.props.dadosProva.exam_time_str}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <p>Basta selecionar a questão para verificar se a mesma encontra-se contestada.</p>
        </div>
      </div>
      <div className="row">
        {Object.keys(self.state.questoes).map(function(k) {
          return (
            <div className="col-md-1">
              <div onClick={() => self.questaoSelecionada(k)} className={(self.state.questoes[k].contested === 1) ? "modal-prova-quadrado-questoes-fundo quadrado-contestada" : (self.state.questoes[k].selected == self.state.questoes[k].option_correct_number) ? "modal-prova-quadrado-questoes-fundo quadrado-correta" : "modal-prova-quadrado-questoes-fundo quadrado-incorreta"}>
                <h5>{(self.state.questoes[k].selected) ? self.state.questoes[k].question_number + ' - ' + self.state.questoes[k].selected_str : self.state.questoes[k].question_number}</h5>
              </div>
            </div>
          );
        })}
      </div>
      <hr/>
      {(this.state.questaoSelecionada === null || typeof this.state.questaoSelecionada === 'undefined') ?  '' :
        <div>
          <h4>{this.state.questao.question_number}</h4>
          <hr/>
          <div className="pull-left" dangerouslySetInnerHTML={{__html: this.state.questao.question_content}}></div>
          <div className="pull-right">{this.state.questao.question_name}</div>
          <div className="clearfix"></div>
          <hr/>
          <table className="table tabela-questao-opcoes">
            <tbody>
              {Object.keys(self.state.opcoes).map(function(k) {
                return (
                  <tr>
                    <td className="checkbox-questao-opcoes"><div className={(self.state.opcoes[k].selected == 1) ? 'opcao-selecionada' : 'opcao'}>{(self.state.opcoes[k].selected == 1) ? 'X' : ''}</div></td>
                    <td><span>{self.state.opcoes[k].option_number}) </span>{self.state.opcoes[k].option_name}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <hr/>
            <h3 className="text-center">Opção correta: <span className="opcao-correta">{this.state.questao.option_correct_number}</span></h3>
              {(this.state.questao.contested === 1) ? <div><hr/><h4 className="bg-danger">Contestação</h4><p>{this.state.questao.message}</p></div> : ""}
          <br/>
          <hr/>
          {(this.state.status_alerta == 1) ? <div><AlertaInline mensagem={this.state.mensagem_alerta} tipo={this.state.tipo_alerta} desativar={this.desativar_alerta} /><br/></div> : ""}
          <label>Justificar questão:</label>
          <textarea style={{ height: 200 }} disabled={this.state.questao.justified == 1 ? "disabled" : ""} value={this.state.questao.justified == 1 ? this.state.questao.justification : this.state.message_justification} type="text" name="content" className="form-control" placeholder="Escreva uma mensagem justificando" onChange={this.state.questao.justified == 1 ? "" : this.handleChange.bind(this, 'message_justification')} />
          <br/>
          <div className="row form-group">
            <div className="col-md-6">
              <button className="btn btn-danger btn-lg btn-block" disabled={this.state.questao.justified == 1 ? "disabled" : ""} onClick={()=>this.justificar(this.state.questao.id)}>NÃO VALIDAR QUESTÃO E ENVIAR JUSTIFICATIVA</button>
            </div>
            <div className="col-md-6">
              <button className="btn btn-success btn-lg btn-block" disabled={this.state.questao.justified === 1 ? "disabled" : "" } onClick={()=>this.validar(this.state.questao.id)}>VALIDAR QUESTÃO E ENVIAR JUSTIFICATIVA</button>
            </div>
          </div>
          {this.state.questao.justified == 1 ? 
            <div className="row form-group">
              <div className="col-md-12">
                <span className={(self.state.questao.validate == 1) ? 'label-success' : 'label-danger'}>{(self.state.questao.validate == 1) ? 'CONTESTAÇÃO VALIDADA' : 'CONTESTAÇÃO INVALIDADA'}</span>
              </div>
            </div>
            : ""
          }
        </div>
      }
      <hr/>
      {(this.state.status_alerta == 1) ? <div><AlertaInline mensagem={this.state.mensagem_alerta} tipo={this.state.tipo_alerta} desativar={this.desativar_alerta} /><br/></div> : ""} 
      {(this.props.dadosProva.status != 'reprovada') ? 
      "" : 
        <div>
          <form>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label>Data da prova:</label>
                  <DatePicker onChange={this.handleChangeDateStartPicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="Data da prova" value={this.state.exam_date} />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Hora inicial:</label>
                  <InputMask value={this.state.hora_inicial}  maskChar={null} name="hora_inicial" mask="99:99:99" className="form-control" onChange={this.handleChange.bind(this, 'hora_inicial')} placeholder="Hora inicial"/>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Hora final:</label>
                  <InputMask value={this.state.hora_final}  maskChar={null} name="hora_final" mask="99:99:99" className="form-control" onChange={this.handleChange.bind(this, 'hora_final')} placeholder="Hora final"/>
                </div>
              </div>
            </div>
          </form>
          <div className="row form-group">
            <div className="col-md-6">
              <button className="btn btn-primary btn-lg btn-block" onClick={()=>this.reaplicarProva()}><i className="fa fa-fw fa-save"></i> Reaplicar prova</button>
            </div>
            <div className="col-md-6">
              <button className="btn btn-success btn-lg btn-block" onClick={()=>this.reaplicarAgora()}> <i className="fa fa-fw fa-refresh"></i>Reaplicar agora</button>
            </div>
              {(this.state.carregando_prova == 1) ? <div className="carregando-prova"><p>Carregando prova a ser reaplicada <i className="fa fa-fw fa-spinner fa-spin"></i></p></div> : ""}
          </div>
        </div>
      }
    </Modal.Body>
  </Modal>
</div>
    );
  }
}

ExamAcoes.contextTypes = {
  router: React.PropTypes.object.isRequired
}

export default ExamAcoes;



// WEBPACK FOOTER //
// ./src/Components/Exams/Elements/ExamAcoes.js